import { render, staticRenderFns } from "./CategoryNavLink.vue?vue&type=template&id=226af5a8&scoped=true&"
import script from "./CategoryNavLink.vue?vue&type=script&lang=js&"
export * from "./CategoryNavLink.vue?vue&type=script&lang=js&"
import style0 from "./CategoryNavLink.vue?vue&type=style&index=0&id=226af5a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226af5a8",
  null
  
)

export default component.exports